<template>
  <div
    class="input-container input-field"
    :class="{
      'input-field--light': light,
      'input-field--appended-icon': !!icon,
      rounded
    }"
  >
    <input
      v-bind="myAttrs"
      :type="type"
      :autocapitalize="autocapitalize"
      :autocomplete="autocomplete"
      :autocorrect="autocorrect"
      :id="id"
      :disabled="disabled"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      ref="input"
      @keyup="keyupCallback ? keyupCallback() : null"
      @input="$emit('update:modelValue', $event.target.value)"
      :style="{ width }"
    />
    <i
      class="mdi pointer"
      :class="icon"
      @click.prevent="iconCallback"
      :title="iconTitle"
      v-if="iconCallback"
    ></i>
    <label ref="label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number]
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String
    },
    id: {
      type: String
    },
    autocapitalize: {
      type: String
    },
    autocomplete: {
      type: String
    },
    autocorrect: {
      type: String
    },
    icon: {
      type: String
    },
    iconTitle: {
      type: String
    },
    iconCallback: {
      type: Function
    },
    keyupCallback: {
      type: Function
    },
    width: {
      type: String,
      default: '100%'
    },
    label: {
      type: String
    },
    light: {
      type: Boolean
    },
    autofocus: {
      type: Boolean
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    if (this.autofocus === true) {
      setTimeout(() => this.$refs.input.focus(), 100);
    }
  },
  methods: {},
  computed: {
    myAttrs() {
      const { onInput, ...attrs } = this.$attrs; // exclude `input`-listener
      return attrs;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.input-field {
  &.rounded {
    input {
      border: 1px solid #ccc !important;
      box-shadow: none !important;
      background-color: #fff !important;
      box-shadow: 0 20px 25px 0 rgba(73, 73, 73, 0.1) !important;
      -webkit-appearance: none;
      appearance: none;
      border-radius: 15px;
      height: auto;
      padding: 20px !important;
      line-height: normal;
    }

    input:disabled {
      opacity: 1; /* required on iOS */
    }

    label {
      margin-left: 20px;
      color: black !important;
      margin-top: 7px;
      &.active {
        margin-top: 0px;
        transform: translateY(2px) scale(0.8) !important;
      }
    }
    i.mdi {
      right: 15px;
      top: 11px;
      font-size: 25px;
    }
  }
}

.input-field--light input {
  color: #fff;
}

.input-field label {
  pointer-events: none;
}
</style>
